import {internalLinkToHref} from 'utils';
import {sanityFetch} from 'utils/sanity.fetch';
import type {LinkReferencesQueryResult} from 'utils/sanity.queries';
import {LINK_REFERENCES_QUERY} from 'utils/sanity.queries';

import type {LinkSchema} from 'components/inline-link/schema';

import {InlineLinkRender} from './render';

interface Props {
	inlineLink: LinkSchema;
	text: string;
	className?: string;
}

export const InlineLinkServer = async ({inlineLink, text, className}: Props) => {
	if (!inlineLink.reference) {
		return null;
	}

	const reference = await sanityFetch<LinkReferencesQueryResult>({
		query: LINK_REFERENCES_QUERY,
		params: {id: inlineLink.reference._ref},
	});

	return (
		<InlineLinkRender
			href={internalLinkToHref(reference?._type, reference?.slug?.current)}
			targetBlank={inlineLink.targetBlank}
			text={text}
			className={className}
		/>
	);
};
